import styled from '@emotion/styled';
import { MediaFragment } from '@graphql/generated/graphql';
import StrapiImage from '@lib/image/strapiImage';
import { getStrapiAssetUrl } from '@lib/strapi';
import { FC } from 'react';

interface Props {
    image?: MediaFragment;
}

const SImage = styled(StrapiImage)`
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    object-fit: cover;
    filter: brightness(0.6);
    z-index: -1;
`;

export const FlowPageBackgroundImage: FC<Props> = ({ image }) => {
    if (!image) return null;

    return (
        <SImage
            src={getStrapiAssetUrl(image)}
            formats={image.formats}
            sizes='(min-width: 748px) 35vw, (max-width: 748px) 100vw'
        />
    );
};
